Jelly.Utilities.Localize_Currency = function(Namespace) {	
	const locale = (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en-US';

	document.querySelectorAll(`${Namespace} .wf-do-format-currency`).forEach((e) => {
		e.innerHTML = new Intl.NumberFormat(locale, { style: 'currency', currency: e.dataset.currencyCode}).format(e.dataset.amount);
	});
}